import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { Button } from '../../../../shared/components/ui/Button';

interface PageHeaderProps {
  onCreate: () => void;
  isLoading: boolean;
}

export function PageHeader({ onCreate, isLoading }: PageHeaderProps) {
  const theme = useTheme();
  
  return (
    <Box style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: 24 
    }}>
      <Box>
        <Typography variant='h4' color={theme.palette.text.primary}>Organizadores</Typography>
        <Typography variant='caption' color={theme.palette.text.secondary}>
          Gerencie os Organizadores do sistema
        </Typography>
      </Box>
      <Button
        variant="contained"
        onClick={onCreate}
        disabled={isLoading}
      >
        + Novo Organizador
      </Button>
    </Box>
  );
}